import { GallerySearchMode } from '../models/gallery-search-mode.enum';
import { GalleryViewMode } from '../models/gallery-view-mode.enum';
import { StudioOptionsModel } from '../models/studio-options.model';
import { SortModel } from 'src/app/shared/components/sort/sort.component';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

export class GalleryStateModel {
    loading: boolean;
    searchMode: GallerySearchMode;
    viewMode: GalleryViewMode;
    
    sort: SortModel;
    sortOptions: SortModel[];

    studioQuery: string;
    studioCategoryId: string;

    studioOptions: StudioOptionsModel[];
    searchResults: BookmarkModel[];

    checkedResults: string[];
}
